import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=926308ea&scoped=true&"
import script from "./VideoList.vue?vue&type=script&lang=ts&"
export * from "./VideoList.vue?vue&type=script&lang=ts&"
import style0 from "./VideoList.vue?vue&type=style&index=0&id=926308ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926308ea",
  null
  
)

export default component.exports